























import {
  Vue,
  servicesURL,
  headers,
  photosUrlEnum,
  mixpanelEvents,
} from "../../constants/constants";
import {
  updatePhotosURL,
  isRTL,
  pushMixpanelEvent,
  isLoggedInUser,
} from "../../helpers";

import { staticContent } from "../../localisation/detect-lang";
import { Glide, GlideSlide } from "vue-glide-js";
import axios from "axios";
import { getRemoteConfigAsBoolean } from "../../firebase";

export default Vue.component("announcemnts-banner", {
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  data() {
    return {
      staticContent,
      photosUrlEnum,
      announcements: [],
      start: 0,
      preventClick: false,
    };
  },

  mounted() {
    this.getAnnouncements();
  },

  computed: {
    carouselOptions() {
      return {
        direction: isRTL ? "rtl" : "ltr",
        type: "carousel",
        rewind: false,
        perView: 1,
        startAt: this.start,
      };
    },
    profile() {
      return this.$store.getters.getProfileData;
    },
    isImpressionTrackEnabled() {
      return (
        getRemoteConfigAsBoolean("Enable_Impression_Track") && isLoggedInUser()
      );
    },
  },
  methods: {
    redirectToRes(url) {
      window.location.href = url;
    },
    resLink(dish) {
      return this.$root.URLBuilder.restaurantURL(
        dish.restaurantName,
        dish.restaurantShortCode,
        this.$root.userCityName ? this.$root.userCityName : "cairo",
        "",
        isRTL ? "AR" : "EN"
      );
    },
    updatePhotosURL(url, version, ext = this.photosUrlEnum.ext.JPG) {
      return updatePhotosURL(url, version, ext);
    },
    getAnnouncements() {
      axios({
        method: "GET",
        url: servicesURL.announcements(
          this.$root.user.areaUUID,
          this.$root.user.zoneUUID
        ),
        headers: headers,
      })
        .then((res) => {
          this.announcements = res.data.announcements;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    visibilityChanged(isVisible, entry, dish, dishIndex) {
      if (isVisible) {
        const {
          uuid,
          data: {
            email,
            profile: { name },
          },
        } = this.profile;

        const userProps = { userName: name, userId: uuid, email };
        const itemProps = {
          hyperlink: dish.targetLink,
          imageUrl: this.updatePhotosURL(dish.photoUrl, 'Normal'), 
          position: dishIndex,
          sourceScreen: "Delivery",
          appSection: "Announcements",
          language: dish.deepLinkData ? dish.deepLinkData.lang : "EN",
        };
        const customProps = {
          "Announcement Title": dish.analyticsTitle,
        };
        pushMixpanelEvent(
          mixpanelEvents.impression.event,
          mixpanelEvents.impression.properties(
            userProps,
            itemProps,
            customProps
          )
        );
      }
    },
  },
});
